<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { parseFilterParams } from '../model/filters/parse-filter-params'
import { useActiveApi } from '../api/active.hook'
import TutorKanbanTable from './TutorKanbanTable.vue'

defineOptions({
  name: 'TutorKanbanActivePage',
})

const route = useRoute()

useOnTimezoneChange(() => {
  const params = parseFilterParams(route.query)
  void useActiveApi({ params })
})
</script>

<template>
  <TutorKanbanTable />
</template>
